import { render, staticRenderFns } from "./MedicationSearchField.vue?vue&type=template&id=99c0af0a&scoped=true"
import script from "./MedicationSearchField.vue?vue&type=script&lang=js"
export * from "./MedicationSearchField.vue?vue&type=script&lang=js"
import style0 from "./MedicationSearchField.vue?vue&type=style&index=0&id=99c0af0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c0af0a",
  null
  
)

export default component.exports